
export const getNameFromEmail = (email) => {
    let originalEmail = email.replace(/[0-9]/g, ''); 
    let emailWithoutAt = originalEmail.split("@")
    let name = emailWithoutAt[0].split(".") ;
    let firstName = name[0] || '', lastName = name[1] || '';
    try {
         name = (firstName && firstName[0] && (firstName[0].toUpperCase() + firstName.substring(1))) + " "  + (lastName && lastName[0] && (lastName[0].toUpperCase() + lastName.substring(1)) )
        return name
    } catch (error) {
    }
}

export function getLabel(label) {
    if (!label) {
        return
    }
    let tempWord = "";
    let finalValue = "";
    if (label === label.toUpperCase()) {
        return label.toUpperCase();
    }
    for (let i = 0; i < label.length; i++) {
        let code = label.charCodeAt(i);
        if (code >= 65 && code <= 92) {
            finalValue += tempWord + " ";
            tempWord = "" + label[i];
        } else {
            tempWord += label[i];
        }
    }

    finalValue = finalValue + tempWord;

    let str = finalValue.toLocaleUpperCase().trim();
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }

    const reqString = str.join(' ').trim();

    return reqString;
}

export const getDataIndexFromLabel = (label) => {
    if(!label){
        return
    }
    let finalValue = "";
    let labelArr = label.split(' ');
    if(labelArr.length > 0) {
        labelArr.forEach((word, index) => {
            if(index === 0){
                finalValue += word.toLowerCase();
            } else {
                finalValue += word.slice(0, 1).toUpperCase() + word.substring(1)
            }
        })
    }
    return finalValue
}

export const getUserDisplayName = (userInfo) => {
    let displayName = userInfo?.displayName
    if(!displayName){
        displayName = userInfo?.name ? userInfo.name.split(" ")[0] : "User"; 
    }
    return displayName
}